// At the moment we're making the assumption that the Jigsaw object exists
import Labs from "./labs";
import Book from "./book";
import User from "./user";
import Viewport from "./viewport";
import Search from "./search";
import wrapper from "./wrapper";

// Let's try to keep these alphabetical
const JigsawAPI = {
  forgotPassword: (opts) => wrapper("forgotPassword", opts),
  getAllAccessCodes: () => wrapper("getAllAccessCodes"),
  getAncillariesForVbid: (isbn) => wrapper("getAncillariesForVbid", isbn),
  getAncillariesSummary: () => wrapper("getAncillariesSummary"),
  getBookInfo: (isbns) => wrapper("getBookInfo", isbns),
  getBookList: (opts) => wrapper("getBookList", opts),
  getCitationInfo: (isbn) => wrapper("getCitationInfo", isbn),
  getCollections: () => wrapper("getCollections"),
  getExpiredBooks: () => wrapper("getExpiredBooks"),
  redeemAncillary: (isbn) => wrapper("redeemAncillary", isbn),
  updateForgottenPassword: (opts) => wrapper("updateForgottenPassword", opts),
  Labs,
  Book,
  Search,
  User,
  Viewport,
  CFIUtils: {
    compareCFIs: (a, b) => wrapper("CFIUtils.compareCFIs", (a, b)),
  },
};

export default JigsawAPI;
